import {Contact} from './contact';
import {Product} from './product';

export class StatusToStr {
  static map = {
    offert: 'Offert',
    active_HD: 'Activé',
    'Not Started': 'Non démarré',
    signe: 'Facturé',
    resilie: 'Résilié',
    annule: 'Annulé',
    mutualise: 'Mutualisé',
    hors_facturation: 'Activé',
    contrat_API: "Activé"
  };

  static crememap = {
    'Activé sur OTRS': 'Activé',
    'Non démarré': 'Non démarré',
    'facturé': 'Facturé',
    'offert': 'Offert',
    'résilié': 'Résilié',
    'hors facturation': 'Activé',
    'mutualisé': 'Mutualisé',
    'Contract API': 'Activé',
    'Résilié - nouveau contrat': 'Annulé',
  };

  static statusToStr(tmp: Contract): string {
    return this.map[tmp.status];
  }
}

export class Contract {
  crmId: string;
  productId: string;
  status: string;
  name: string;

  contacts: Contact[];
  product: Product;
  dp: Contact;
}
